/**
 * ミツカン試食室 商品ページ JavaScript
 */

document.addEventListener('DOMContentLoaded', function() {
  initSortTabs();
  initTextToggles();
  initReviewsMore();
});

/**
 * ソートタブの初期化
 */
function initSortTabs() {
  const sortTabs = document.querySelectorAll('.tasting-room-sort-tabs__tab');
  const reviewsList = document.querySelector('.tasting-room-product__reviews-list');
  
  if (!sortTabs.length || !reviewsList) return;

  sortTabs.forEach(function(tab) {
    tab.addEventListener('click', function() {
      const sortType = this.dataset.sort_by;
      
      // アクティブ状態の更新
      sortTabs.forEach(function(t) {
        t.classList.remove('is-active');
      });
      this.classList.add('is-active');
      
      // ソート実行
      sortReviews(sortType, reviewsList);
      
      // データ属性を更新
      reviewsList.dataset.sort_by = sortType;
    });
  });
}

/**
 * レビューをソート
 * @param {string} sortType - ソート種別（likes/rating/newest）
 * @param {HTMLElement} container - レビューリストのコンテナ
 */
function sortReviews(sortType, container) {
  const reviews = Array.from(container.querySelectorAll('.tasting-room-review-card'));
  
  reviews.sort(function(a, b) {
    let aValue, bValue;
    
    switch(sortType) {
      case 'likes':
        aValue = parseInt(a.querySelector('.tasting-room-like-button__count')?.textContent || '0');
        bValue = parseInt(b.querySelector('.tasting-room-like-button__count')?.textContent || '0');
        return bValue - aValue; // 降順
      case 'rating':
        aValue = parseFloat(a.querySelector('.tasting-room-review-card__rating-value')?.textContent || '0');
        bValue = parseFloat(b.querySelector('.tasting-room-review-card__rating-value')?.textContent || '0');
        return bValue - aValue; // 降順
      case 'newest':
        // 作成日時で降順ソート（data-created-at属性を使用）
        aValue = new Date(a.dataset.createdAt || 0).getTime();
        bValue = new Date(b.dataset.createdAt || 0).getTime();
        return bValue - aValue; // 降順（新しい順）
      default:
        return 0;
    }
  });
  
  // DOMを再構築
  reviews.forEach(function(review) {
    container.appendChild(review);
  });
}

/**
 * レビュー本文の「もっと見る」機能
 */
function initTextToggles() {
  const toggles = document.querySelectorAll('.tasting-room-review-card__text-toggle');
  
  toggles.forEach(function(toggle) {
    toggle.addEventListener('click', function() {
      const reviewId = this.dataset.reviewId;
      const card = this.closest('.tasting-room-review-card');
      const shortText = card.querySelector('.tasting-room-review-card__text-short');
      const fullText = card.querySelector('.tasting-room-review-card__text-full');
      
      if (!shortText || !fullText) return;
      
      const isExpanded = fullText.style.display !== 'none';
      
      if (isExpanded) {
        shortText.style.display = 'block';
        fullText.style.display = 'none';
        this.textContent = 'もっと見る';
      } else {
        shortText.style.display = 'none';
        fullText.style.display = 'block';
        this.textContent = '閉じる';
      }
    });
  });
}

/**
 * 「みんなの試食レビューをもっと見る」ボタン
 */
function initReviewsMore() {
  const moreButton = document.querySelector('.tasting-room-product__reviews-more');
  
  if (!moreButton) return;
  
  moreButton.addEventListener('click', function() {
    // 後でAPI呼び出しで追加のレビューを読み込む実装を追加
    // loadMoreReviews();
  });
}

/**
 * 追加のレビューを読み込む
 */
async function loadMoreReviews() {
  try {
    const reviewsList = document.querySelector('.tasting-room-product__reviews-list');
    const currentSort = reviewsList?.dataset.sort_by || 'rating';
    const currentCount = reviewsList?.querySelectorAll('.tasting-room-review-card').length || 0;
    
    // 後でAPIエンドポイントを実装
    const endpoint = '/apps/proxy/api/customers/reviews?sort=' + currentSort + '&offset=' + currentCount;
    const response = await fetch(endpoint);
    
    if (!response.ok) {
      throw new Error('レビューの読み込みに失敗しました');
    }
    
    const result = await response.json();
    // レビューを追加する処理を実装
    
  } catch (error) {
    console.error('レビューの読み込みエラー:', error);
  }
}
